import { AbstractControl } from "@angular/forms";
import { validationRegex } from "@obg/ngx.global";

export function italianTaxCodeValidator(control: AbstractControl): { format?: boolean } | null {
	const value = String(control.value);
	const taxCodeRegex = validationRegex.alphanumeric;

	if (value.length === 16 && value.match(taxCodeRegex)) {
		return null;
	}

	return { format: false };
}
